module.exports = __webpack_public_path__ + "static/media/LifeMap.e49fa0e9.webp";